import { callIf } from "./fn";

const isOutsideOf = el => ({ target }) => !(el === target || el.contains(target));

const onOutsideClick = (el, handler) => {
	const documentClickHandler = callIf(isOutsideOf(el), handler);
	document.addEventListener("click", documentClickHandler);
	return () => document.removeEventListener("click", documentClickHandler);
};

export default onOutsideClick;
